import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const HUBS = ["London", "New York", "Berlin", "Sydney", "Tokyo"];

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer data-testid="main-footer" className="bg-tour-void text-white">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <button
          data-testid="footer-cta"
          onClick={() => navigate("/enquiry")}
          className="group block text-left font-display text-4xl font-extrabold leading-none tracking-tighter transition-colors hover:text-tour-red sm:text-6xl lg:text-7xl"
        >
          LET'S STOCK YOUR
          <span className="mt-2 flex items-center gap-4 font-serif italic font-medium">
            merch table
            <ArrowUpRight className="h-10 w-10 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 sm:h-14 sm:w-14" />
          </span>
        </button>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-zinc-800 pt-10 sm:grid-cols-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Print hubs</p>
            <p className="mt-3 font-mono text-xs tracking-widest text-zinc-300">{HUBS.join(" · ")}</p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Contact</p>
            <a data-testid="footer-email-link" href="mailto:info@poitinrepublic.com" className="mt-3 block font-mono text-xs tracking-widest text-zinc-300 transition-colors hover:text-tour-red">
              info@poitinrepublic.com
            </a>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Hours</p>
            <p className="mt-3 font-mono text-xs tracking-widest text-zinc-300">Mon–Sat · 09:00–19:00 GMT</p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-zinc-800 pt-8 sm:flex-row sm:items-center">
          <p className="font-display text-sm font-extrabold uppercase tracking-tight">Poitín Republic</p>
          <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
            © 2026 Poitín Republic. Design · Print · Deliver.
          </p>
        </div>
      </div>
    </footer>
  );
}
